<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Bases por Rutas</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button type="button" @click="consultar" id="consultar" class="btn-info btn--bigger">
            <i class="fa fa-search" aria-hidden="true"></i><span>Consultar</span>
          </button>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-6">
            <div class="form-group select2">
              <div class="select2-field select2-field--stretch">
                <v-select multiple v-model="rutasSeleccionadas" id="rutas" placeholder="Todas..." :options="rutas"
                  @search="onSearchRutas" label="descripcion">
                </v-select>
                <label for="rutas">Rutas</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-inline form-inline--stretch">
              <div class="form-inline__title">
                Estado
              </div>
              <div class="form-inline__content">
                <label>
                  <input v-model="form.estado_ruta" type="radio" value="A" />
                  <span>Activos</span>
                </label>
                <label>
                  <input v-model="form.estado_ruta" type="radio" value="I" />
                  <span>Inactivos</span>
                </label>
                <label>
                  <input v-model="form.estado_ruta" type="radio" value="T" />
                  <span>Todos</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12">
            <vue-good-table 
              :columns="columns" 
              mode="remote"
              :pagination-options="{
                enabled: true,
                perPage: 20,
                perPageDropdown: [],
                nextLabel: 'siguiente',
                prevLabel: 'anterior',
                rowsPerPageLabel: 'Registros por página',
                ofLabel: 'de',
                allLabel: 'Todo',
                dropdownAllowAll: true
              }" 
              :rows="registros" 
              :search-options="{
                enabled: false
              }" 
              styleClass="vgt-table vgt-table--sticky"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'saldo.fecha'">
                  {{ props.row.saldo ? props.row.saldo.fecha.split(' ')[0] : '-' }}
                </span>
                <span v-else-if="props.column.field == 'saldo.saldo'">
                  {{ props.row.saldo ? moneyFormat(props.row.saldo.saldo) : '-' }}
                </span>
                <span v-else-if="props.column.field == 'acciones'  && props.row.saldo">
                  <button v-if="puedeEditar" type="button" @click="editar(props.row)" class="btn-success btn--text"><i class="fa fa-edit"></i></button>
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>

    <modal :clickToClose="false" name="base" width="50%" height="auto" scrollable>
      <saldo-base @saved="saved" @cancelar="cancelar" v-model="rutaSeleccionada"></saldo-base>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    columns: {
      type: Array,
      required: false,
      default: function () {
        return [
          {
            label: 'Rutas',
            field: 'descripcion'
          },
          {
            label: 'Fecha',
            field: 'saldo.fecha'
          },
          {
            label: 'Saldo',
            field: 'saldo.saldo'
          },
          {
            label: 'Acciones',
            field: 'acciones'
          }
        ];
      }
    },
    puedeConsultar: {
      type: Boolean,
      required: false,
      default: false,
    },
    puedeEditar: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  data: function () {
    return {
      moneyFormat: moneyFormat,
      registros: [],
      rutas: [],
      rutasSeleccionadas: [],
      rutaSeleccionada: null,
      form: {
        estado_ruta: 'A',
        fecha_desde: moment(new Date()).format('YYYY-MM-DD'),
        fecha_hasta: moment(new Date()).format('YYYY-MM-DD'),
        idsRutas: []
      }
    }
  },
  watch: {
    'form.fecha_desde': function (value) {
      if (value != null && value != undefined) {
        if (value.length == 10) {
          let date = new Date(value);
          if (date == 'Invalid Date') {
            swal('Error', 'La fecha inicial es incorrecta', 'error');
            this.form.fecha_desde = null;
          }
        }
      }
    },
    'form.fecha_hasta': function (value) {
      if (value != null && value != undefined) {
        if (value.length == 10) {
          let date = new Date(value);
          if (date == 'Invalid Date') {
            swal('Error', 'La fecha final es incorrecta', 'error');
            this.form.fecha_hasta = null;
          }
        }
      }
    },
    rutasSeleccionadas: function () {
      this.form.idsRutas.splice(0, this.form.idsRutas.length);
      for (let i = 0; i < this.rutasSeleccionadas.length; i++) {
        this.form.idsRutas.push(this.rutasSeleccionadas[i].id);
      }
    }
  },
  methods: {
    consultar: function () {
      if (this.validarFiltros()) {
        let that = this;
        let urlApi = url + '/logistica/bases-rutas/';
        this.form.tipo_consulta = 'C';
        axios.get(urlApi, {
          params: this.form
        }).then(function (response) {
          that.registros = JSON.parse(JSON.stringify(response.data.basesRutas));
        }).catch(function (error) {
          swal('Error', 'No se pudo consultar los registros, intente nuevamente', 'error');
        });
      }
    },
    validarFiltros: function () {
      if (this.form.tipo_fecha == 'P') {
        if (this.form.fecha_desde == null || this.form.fecha_hasta == null) {
          swal('Aviso', 'Debe ingresar las fechas', 'warning');
          return false;
        }
        else if (this.form.fecha_desde.length != 10 || this.form.fecha_hasta.length != 10) {
          swal('Aviso', 'Debe ingresar las fechas de manera correcta', 'warning');
          return false;
        }
      }
      return true;
    },
    onSearchRutas: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.rutas = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open("GET", url + "/search/rutas?search=" + search, true);
      xmlhttp.send();
    },
    editar: function (row) {
      let [year, month, day] = row.saldo.fecha.split(' ')[0].split('-');
      let date = new Date(year, month - 1, day);
      let formattedDate = date.toLocaleDateString('en-GB');
      this.rutaSeleccionada = {
        id: row.saldo ? row.saldo.id : null,
        ruta: row.descripcion,
        fecha: formattedDate,
        saldo: row.saldo ? row.saldo.saldo : 0,
      };
      this.$modal.show("base");
    },
    saved: function (row) {
      this.consultar()
      this.$modal.hide("base");
    },
    cancelar: function () {
      this.$modal.hide("base");
    },
  },
  mounted: function () {
    this.consultar();
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/basesrutas/BaseRuta.vue